import { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Outlet, useLocation } from 'react-router-dom'

export const Seo = () => {
    const [title, setTitle] = useState('')
    const location = useLocation()

    useEffect(() => {
        const pathname = location.pathname
        if (pathname.includes('/merchant/builder')) {
            setTitle('Create Template')
        } else if (pathname == '/merchant/template_library') {
            setTitle('Template Library')
        } else if (pathname == '/merchant/create_blog_campaign_v2') {
            setTitle('Create Blog Campaign')
        } else if (pathname == '/merchant/create_ai_quotes_campaign_v2') {
            setTitle('Create Campaign')
        } else if (pathname == '/merchant/create_video_campaign') {
            setTitle('Create Video Campaign')
        } else if (pathname == '/merchant/create_listing_campaign') {
            setTitle('Create Listing Campaign')
        } else if (pathname == '/merchant/calendar_v2') {
            setTitle('Calendar')
        } else if (pathname == '/merchant/view_campaigns') {
            setTitle('Campaigns')
        } else if (pathname.includes('/merchant/view_campaign_v2')) {
            setTitle('View Campaign')
        } else if (pathname.includes('/merchant/campaign')) {
            setTitle('Edit Asset')
        } else if (pathname == '/merchant/pricing') {
            setTitle('Choose Your Plan')
        } else if (pathname == '/merchant/settings') {
            setTitle('Settings')
        } else if (pathname == '/merchant/onboarding') {
            setTitle('Onboarding')
        } else if (pathname == '/auth/login') {
            setTitle('Bruce | Login')
        } else if (pathname == '/auth/signup') {
            setTitle('Bruce | Sign Up')
        } else if (pathname.includes('/merchant/template_builder')) {
            if (pathname.includes('edit')) {
                setTitle('Edit Template')
            } else if (pathname.includes('preview')) {
                setTitle('Preview Template')
            }
        } else {
            setTitle('Bruce')
        }
    }, [location])

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <Outlet />
        </>
    )
}
